import React, { Component } from "react"
import GlobalHeaderWrapper from "./globalHeaderWrapper"
import PropTypes from "prop-types"
import Icon from "../icon-v2"
import Menu from "./Menu"
import SbEditable from "storyblok-react"
import Components from ".."
import linkHandler from "../../helpers/storyblokLinkHandler"
import PageNav from "./PageNav"
import Cookies from "js-cookie"
import { getKey } from "../../helpers/getKey"
import {
  StyledNotification,
  StyledNotificationDummy,
  StyledNotificationMessage,
  StyledNotificationText,
  StyledNotificationClose,
} from "./partials/StyledGlobalHeader"
import IconV2 from "../icon-v2"
import {
  notificationClosed,
  closeNotification,
} from "../../helpers/handleCookies"

class NotificationBar extends Component {
  state = {
    displayNotice: true,
    isSticky: false,
  }

  componentDidMount(blok) {
    if (window && typeof window !== "undefined") {
      window.addEventListener("scroll", () => {
        this.handleScroll()
      })
    }
    if (notificationClosed(this.props.notification_id)) {
      this.setState({
        displayNotice: false,
      })
    } else {
      this.setState({
        displayNotice: true,
      })
    }
  }
  hideNotice = () => {
    const { displayNotice } = this.state
    this.setState({
      displayNotice: false,
    })
    closeNotification(this.props.notification_id)
  }
  render() {
    let { blok } = this.props
    if (!blok) {
      blok = this.props
    }
    return (
      <>
        <StyledNotification
          variant={blok.notification_variant}
          display_notice={this.state.displayNotice}
          notification_id={blok.notification_id}
        >
          <StyledNotificationDummy>
            <IconV2 icon="times" />
          </StyledNotificationDummy>
          <StyledNotificationMessage display_notice={this.state.displayNotice}>
            <StyledNotificationText>
              {blok.notification_text}
            </StyledNotificationText>
            {blok.notification_cta &&
              blok.notification_cta.length > 0 &&
              blok.notification_cta.map((content, idx) =>
                React.createElement(Components(content.component), {
                  key: getKey(
                    "header-notification-",
                    content._uid ? content._uid : idx
                  ),
                  blok: content,
                })
              )}
          </StyledNotificationMessage>
          <StyledNotificationClose
            onClick={() => this.hideNotice()}
            display_notice={this.state.displayNotice}
          >
            <IconV2 icon="times" iconType="fal" size="14" />
          </StyledNotificationClose>
        </StyledNotification>
      </>
    )
  }
}
export default NotificationBar
